<template>
  <form class="form form-loyalty-signup-details mb-0" @submit.prevent="postDetails">
    <slide-x-left-transition :duration="400" :delay="300">
      <div class="form-group" v-show="show">
        <label>Nazwa lokalu:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="name"
                 :class="{'input-error' : errors['company_data.name'] }"
                 placeholder="Nazwa lokalu">
        </div>
        <p class="error" v-if="errors['company_data.name']" v-text="errors['company_data.name'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="400">
      <div class="form-group" v-show="show">
        <label>Nip firmy:</label>
        <div class="input-wrapper">
          <input type="number"
                 v-model="tax_id"
                 :class="{'input-error' : errors['company_data.tax_id'] }"
                 v-mask="'##########'"
                 placeholder="Nip firmy">
        </div>
        <p class="error" v-if="errors['company_data.tax_id']" v-text="errors['company_data.tax_id'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="500">
      <div class="form-group" v-show="show">
        <label>Miasto:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="city"
                 :class="{'input-error' : errors['company_data.city'] }"
                 placeholder="Miasto">
        </div>
        <p class="error" v-if="errors['company_data.city']" v-text="errors['company_data.city'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="600">
      <div class="form-group" v-show="show">
        <label>Ulica</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="street"
                 :class="{'input-error' : errors['company_data.street'] }"
                 placeholder="Ulica i numer domu">
        </div>
        <p class="error" v-if="errors['company_data.street']" v-text="errors['company_data.street'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="600">
      <div class="form-group" v-show="show">
        <label>Numer domu:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="street_no"
                 :class="{'input-error' : errors['company_data.street_no'] }"
                 placeholder="Ulica i numer domu">
        </div>
        <p class="error" v-if="errors['company_data.street_no']" v-text="errors['company_data.street_no'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="800">
      <div class="form-group" v-show="show">
        <label>Kod pocztowy:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="zip_code"
                 :class="{'input-error' : errors['company_data.zip_code'] }"
                 v-mask="'##-###'"
                 placeholder="Kod pocztowy">
        </div>
        <p class="error" v-if="errors['company_data.zip_code']" v-text="errors['company_data.zip_code'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="900">
      <div class="form-group" v-show="show">
        <label>Marka komunikowana:</label>
        <div class="select-wrapper">
          <span v-if="brand === null" class="select-placeholder">Wybierz markę</span>
          <select v-model="brand" :class="{'input-error' : errors['brand'] }">
            <option v-for="option in brands" :value="option.slug">{{ option.name }}</option>
          </select>
        </div>
        <p class="error" v-if="errors['brand']" v-text="errors['brand'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1000">
      <div class="form-group" v-show="show">
        <label>Area:</label>
        <div class="select-wrapper">
          <span v-if="area === null" class="select-placeholder">Wybierz area</span>
          <select v-model="area" :class="{'input-error' : errors['area'] }">
            <option v-for="option in areas" :value="option">{{ option }}</option>
          </select>
        </div>
        <p class="error" v-if="errors['area']" v-text="errors['area'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1100">
      <p v-if="show">Zaznacz wymagane zgody:</p>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1200">
      <div class="form-group" v-show="show">
        <template v-for="(item,index) in loyalty_details_agreements">
          <div class="input-wrapper">
            <!--v-model not working - value is passed as props 'checked'-->
            <ion-checkbox mode="md"
                          :checked="tempAgreements.length > 0 ? tempAgreements[index].isChecked : false"
                          @input="checked = target.value"
                          @ionChange="handleCheckbox($event, index, item.key, item.value)">
            </ion-checkbox>
            <label class="checkbox-label">{{ item.value }}</label>
          </div>
          <p class="error"
             v-if="errors['agreements.'+ item.key]"
             v-text="errors['agreements.'+ item.key][0]">
          </p>
        </template>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1300">
      <hr v-if="show"/>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400">
      <div class="form-group" v-if="show">
        <div class="input-wrapper">
          <ion-checkbox
              @ionChange="payer_office = $event.target.checked || false"
              :checked="payer_office"
              mode="md">
          </ion-checkbox>
          <label class="checkbox-label">Dodać siedzibę płatnika?</label>
        </div>
      </div>
    </slide-x-left-transition>
    <!--payer office hidden fields-->
    <slide-x-left-transition :duration="400" :delay="100">
      <div v-if="show && payer_office === true">
        <div class="form-group">
          <label>Numer ID_SFA:</label>
          <div class="input-wrapper">
            <input v-model="payer_office_sfa"
                   type="number"
                   :class="{'input-error' : errors['company_data.payer_office_number.sfa'] }"
                   placeholder="Podaj ID_SFA lokalu">
          </div>
          <p class="error"
             v-if="errors['company_data.payer_office_number.sfa']"
             v-text="errors['company_data.payer_office_number.sfa'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="200">
      <div v-if="show && payer_office === true">
        <div class="form-group">
          <label>Udział keg %:</label>
          <div class="input-wrapper">
            <input v-model="payer_office_keg"
                   type="number"
                   :max="100"
                   v-mask="'###'"
                   :class="{'input-error' : errors['company_data.payer_office_number.keg'] }"
                   placeholder="Udział keg w %">
          </div>
          <p class="error"
             v-if="errors['company_data.payer_office_number.keg']"
             v-text="errors['company_data.payer_office_number.keg'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="300">
      <div v-if="show && payer_office === true">
        <div class="form-group">
          <label>Udział butelka %:</label>
          <div class="input-wrapper">
            <input v-model="payer_office_bottle"
                   type="number"
                   :max="100"
                   v-mask="'###'"
                   :class="{'input-error' : errors['company_data.payer_office_number.bottle'] }"
                   placeholder="Udział butelka w %">
          </div>
          <p class="error"
             v-if="errors['company_data.payer_office_number.bottle']"
             v-text="errors['company_data.payer_office_number.bottle'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goToStep(0)"
                    class="mt-10">Wstecz
        </ion-button>
        <ion-button mode="ios"
                    size="small"
                    @click="postDetails"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import { cloneDeep } from 'lodash';
  import { createHelpers } from "vuex-map-fields";
  import {mapState} from "vuex";
  import store from "../../../store";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'LoyaltySignupDetails',
    computed: {
      ...mapFields({
        name : 'signupForm.company_data.name',
        tax_id : 'signupForm.company_data.tax_id',
        city : 'signupForm.company_data.city',
        street : 'signupForm.company_data.street',
        street_no : 'signupForm.company_data.street_no',
        zip_code : 'signupForm.company_data.zip_code',
        brand : 'signupForm.brand',
        area : 'signupForm.area',
        payer_office : 'signupForm.company_data.payer_office',
        payer_office_sfa : 'signupForm.company_data.payer_office_number.sfa',
        payer_office_keg : 'signupForm.company_data.payer_office_number.keg',
        payer_office_bottle : 'signupForm.company_data.payer_office_number.bottle',
        agreements : 'signupForm.agreements'
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
        brands: state => state.loyalty.brands,
        areas: state => state.global.areas,
        loyalty_details_agreements: state => state.global.agreements.loyalty_details
      }),
    },
    data() {
      return {
        show: false,
        tempAgreements: [] // helper
      }
    },
    mounted(){
      this.show = true
      if(!this.brands.length){
        this.$store.dispatch('loyalty/LOYALTY_BRANDS_REQUEST')
      }
      this.resetAgreements()
    },
    methods: {
      handleCheckbox(event, i, key, value) {
        const checkbox = event.target
        // prepare agreements
        let obj = {
          [key]: value
        }
        // checkbox is set true
        if (checkbox.checked) {
          this.tempAgreements[i].isChecked = true
          // before adding obj to obj
          // check duplicates
          const isDuplicate = this.agreements.hasOwnProperty(obj)
          if(!isDuplicate){
            Object.assign(this.agreements, obj)
          }
        }
        // checkbox is set false
        else{
          this.tempAgreements[i].isChecked = false
          // remove agreement item by key
          // unfortunately delete must be done via vuex mutation(!)
          const key = Object.keys(obj)[0]
          this.$store.commit('loyalty/LOYALTY_REMOVE_AGREEMENT', key)
        }
      },
      resetAgreements(){
        // always reset agreements
        this.tempAgreements = []
        // remove agreement item by key
        this.loyalty_details_agreements.forEach((item) => {
          this.$store.commit('loyalty/LOYALTY_REMOVE_AGREEMENT', item.key)
        })
        // copy global agreements to local halper and unbind two-way
        this.tempAgreements = _.cloneDeep(this.loyalty_details_agreements)
      },
      goToStep(step){
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_CURRENT_STEP', step)
      },
      postDetails(){
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_STORE_REQUEST', 2)
      }
    }
  }
</script>